import { Button, Card, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Images } from "../../../../assets";
import styled from "styled-components";
import { Flex } from "antd";
import React from "react";

const Inactive = ({ activate = () => {}, readMore = () => {} }) => (
  <Styled background={`url(${Images.connectInactiveCardBg})`}>
    <Text
      level={4}
      weight={700}
      lineHeight="normal"
      children={Localization.general.connect}
    />
    <Text
      weight={700}
      type="tertiary"
      className="m-5-t"
      children={Localization.service.connect_inactive_subtitle}
    />
    <Text
      weight={400}
      type="tertiary"
      className="m-30-t desc"
      children={Localization.service.connect_inactive_desc}
    />
    <Flex className="m-50-t" gap={"1rem"}>
      <Button
        type="primary"
        onClick={activate}
        title={Localization.general.activate}
      />
      <Button
        color="tertiary"
        onClick={readMore}
        title={Localization.general.read_more}
      />
    </Flex>
  </Styled>
);

const Styled = styled(Card)`
  .desc {
    padding-right: 6.5rem;
    ${(_) => _.theme.mobile(`padding-right: 0;`)}
  }
`;

export default Inactive;
